// import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashboardLayout from "./layout/DashboardLayout";
import EmployeesView from "./pages/Employees/EmployeesView";
import CategoriesView from "./pages/Categories/CategoriesView";
import ExpensesView from "./pages/Expenses/ExpensesView";
import LoginView from "./views/LoginView";
import ManagesView from "./pages/Manages/ManagesView";
import InvoicesView from "./pages/invoices/invoices";
import AuthGuard from "./components/AuthGuard";
import { HashRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
  <HashRouter>
  <Routes>
    <Route path="/" element={<LoginView />} />

    <Route element={<AuthGuard />}>
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route path="employees" element={<EmployeesView />} />
        <Route path="categories" element={<CategoriesView />} />
        <Route path="expenses" element={<ExpensesView />} />
        <Route path="manage" element={<ManagesView />} />
         <Route path="invoice" element={<InvoicesView />} />
      </Route>
    </Route>
  </Routes>
</HashRouter>

  );
}

export default App;
